/* eslint-disable */
import { useEffect, useState } from 'react';
import { getHigherUnitName } from '@/Helpers';
import moment from 'moment';

export const header = [
	{
		title: 'S. NO',
		key: 'sno',
		width: 60,
		fixed: true,
		customCol: true,
	},
	{
		title: 'Item Name',
		key: 'itemName',
		fixed: true,
		customCol: true,
		sortable: true,
	},
	{
		title: 'SKU Code',
		key: 'skuCode',
		fixed: true,
		customCol: true,
	},
];

export const shortMonthNames = [
	'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
	'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

export const monthsColumns = () => {
	const date = new Date();
	const currentMonth = date.getMonth();
	const prevMonth = currentMonth === 0 ? 11 : currentMonth - 1;
	const currentYear = date.getFullYear() ;
	const months = [];
	const selectedMonths = [];
	for (let m = 0; m <= prevMonth; m++) {
		selectedMonths.push(m);
	}
	selectedMonths.reverse().forEach((monthIndex) => {
		const title = `${shortMonthNames[monthIndex].toUpperCase()} ${currentYear}`;
		months.push({
			title,
			key: String(monthIndex),
			customCol: true,
		});
	});
	return [
		...header,
		...months,
	];
};

export const PriceInput = ({ product, month, onUpdate, daysLimit }) => {
	const currentMonth = new Date().getMonth();
	const prevMonth = currentMonth === 0 ? 11 : currentMonth - 1;
	const currentDate = new Date().getDate();
	const [localValue, setLocalValue] = useState(product?.[month] || '');

	const handleKeyDown = (e) => {
		if (['e', 'E', '+', '-'].includes(e.key)) {
			e.preventDefault();
		}
	};
	
	const handleChange = (value) => {
		setLocalValue(value);
		onUpdate(value, month, product.id);
	};
	if (Number(month) === Number(prevMonth) && currentDate <= daysLimit) {
		return (
			<div className='flex items-center gap-2'>
				<input
					className='text-center text-[14px] w-[60px] border border-gray-300 focus:border-blue-500 outline-none transition-colors duration-200'
					style={{
						borderRadius: '4px',
						padding: '2px 6px',
					}}
					type='number'
					value={localValue}
					onChange={(e) => handleChange(e.target.value)}
					onKeyDown={handleKeyDown}
				/>
				<p className='text-gray-700 text-left text-[12px]'>
					₹/
					{getHigherUnitName(product?.unit)}
				</p>
			</div>
		);
	}
	return (
		<div className='flex items-center gap-2 text-gray-700 text-[12px] min-w-[80px]'>
			<span>{Number(product?.[month] || '').toFixed(2)}</span>
			<span className='text-[12px]'>₹/{getHigherUnitName(product?.unit)}</span>
		</div>
	);
};

export const getSelectedStoreName = (selectedStore, storeList) => {
	if (!selectedStore || !storeList) {
		return null;
	}
	const storeName = storeList.find((item) => Number(item?.id) === Number(selectedStore))?.name;
	return storeName;
};

export const getFormattedDate = (month) => {
	const currentDate = new Date();
	const currentMonth = currentDate.getMonth();
	const currentYear = currentDate.getFullYear();
	const day = currentDate.getDate();
	let year = currentYear;
	if (month > currentMonth) {
		year = currentYear - 1;
	}
	const monthIndex = Number(month) + 1;
	const formattedDate = String(day).padStart(2, '0');
	const formattedMonth = String(monthIndex).padStart(2, '0');
	return `${year}-${formattedMonth}-${formattedDate}`;
};

export const getCurrentDateInfo = () => {
	const now = new Date();
	return {
		currentMonth: now.getMonth(),
		currentYear: now.getFullYear(),
	};
};

export const handleExport = (generatedData, monthKeys = []) => {
	const headers = ['sno', 'itemName', 'skuCode', 'unit', ...monthKeys.map((month) => shortMonthNames[month])];
	const rows = generatedData?.map((item) => {
		return [item?.sno, item?.itemName, item?.skuCode, getHigherUnitName(item?.unit), ...monthKeys?.map((month) => item[month])];
	});
	const csvData = [headers, ...rows];
	const csvContent = csvData.map((row) => row.join(',')).join('\n');
	const csvFile = new Blob([csvContent], { type: 'text/csv' });
	const downloadLink = document.createElement('a');
	downloadLink.download = `rm-price-update-${moment(new Date()).format('YYYY-MM-DD')}.csv`;
	downloadLink.href = URL.createObjectURL(csvFile);
	downloadLink.style.display = 'none';
	document.body.appendChild(downloadLink);
	downloadLink.click();
	window.URL.revokeObjectURL(downloadLink.href);
	document.body.removeChild(downloadLink);
};
